
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Freshfruit.css"; // slick ki CSS ke baad hi import karna
import { useNavigate } from "react-router-dom";
import axios from "axios";

// Apni public folder wali placeholder file ka sahi naam/extension rakho
const PLACEHOLDER = "/no-image-placeholder.png";

const CustomPrevArrow = ({ onClick }) => (
  <button
    type="button"
    aria-label="Previous"
    className="freshfruit-prev-arrow"
    onClick={onClick}
  >
    <i className="las la-angle-left" />
  </button>
);

const CustomNextArrow = ({ onClick }) => (
  <button
    type="button"
    aria-label="Next"
    className="freshfruit-next-arrow"
    onClick={onClick}
  >
    <i className="las la-angle-right" />
  </button>
);

const Freshfruit = () => {
  const navigate = useNavigate();

  const handleCategoryClick = (categoryName) => {
    const slug = (categoryName || "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");
    navigate(`/top-cashback-stores?category=${slug}`);
  };

  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCategories = async () => {
    try {
      setError(null);
      setLoading(true);

      const { data } = await axios.get(
        `${process.env.REACT_APP_API}website/category_list`
      );

      if (data?.result) {
        let list = data.data || [];

        // Agar 6 se kam categories hain to repeat karke fill karo
        if (list.length > 0 && list.length < 6) {
          const repeated = [];
          let i = 0;
          while (repeated.length < 6) {
            repeated.push({ ...list[i % list.length], _repeatKey: i });
            i++;
          }
          list = repeated;
        }

        setCategoryList(list);
      } else {
        setError("No categories found");
      }
    } catch (err) {
      console.error(err);
      setError("Failed to load categories");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  if (loading)
    return (
      <div className="freshfruit-loading-container">
        <div className="freshfruit-loading-spinner"></div>
        <p className="freshfruit-loading-text">Loading categories...</p>
      </div>
    );

  if (error)
    return (
      <div className="freshfruit-error-container">
        <div className="freshfruit-error-icon">⚠️</div>
        <p className="freshfruit-error-text">{error}</p>
        <button
          type="button"
          className="freshfruit-retry-button"
          onClick={fetchCategories}
        >
          Try Again
        </button>
      </div>
    );

  // Koi category na ho to section hi na dikhao
  if (categoryList.length === 0) return null;

  const total = categoryList.length;

  // n cards dikhane hain; agar total kam ho to slider chalane ki zarurat nahi
  const view = (n) => ({
    slidesToShow: Math.min(n, total),
    infinite: total > n,
    arrows: total > n,
  });

  const settings = {
    ...view(6),
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 700,
    cssEase: "ease-in-out",
    slidesToScroll: 1,
    swipeToSlide: true,
    dots: false,
    pauseOnHover: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
   responsive: [
      { breakpoint: 1199, settings: view(5) },
      { breakpoint: 991, settings: view(4) },
      { breakpoint: 767, settings: view(3) },
      { breakpoint: 575, settings: view(2) },
      { breakpoint: 399, settings: view(1) },
    ],
  };

  return (
    <section className="freshfruit-section">
      <div className="container">
        <div className="freshfruit-section-header">
          <span className="freshfruit-eyebrow">What We Offer</span>
          <h2 className="freshfruit-section-title">
            Browse by <span>Category</span>
          </h2>
          <p className="freshfruit-section-subtitle">
            From traditional sweets to festive specials — find your favourite
          </p>
        </div>

        <Slider {...settings} className="freshfruit-slider">
          {categoryList.map((item, index) => (
            <div key={item._id + "-" + index} className="freshfruit-slide-item">
              <div
                className="freshfruit-card"
                onClick={() => handleCategoryClick(item.category_name)}
              >
                <div className="freshfruit-image-wrap">
                  <img
                    src={
                      item.category_image
                        ? `${process.env.REACT_APP_API}uploads/${item.category_image}`
                        : PLACEHOLDER
                    }
                    alt={item.category_name || "Category"}
                    loading="lazy"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = PLACEHOLDER;
                    }}
                  />
                </div>
                <h3 className="freshfruit-card-title">
                  <span className="freshfruit-card-name">
                    {item.category_name}
                  </span>
                </h3>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Freshfruit;